// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors"], function() { return __webpack_require__("./src/beta/assets/styles/sections/main-article.scss"); })
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors"], function() { return __webpack_require__("./src/beta/assets/scripts/sections/main-article.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
